export default class Language {
    constructor(readonly name: string, readonly localeCode: string) {}
}
